
export const initialState = {
    tutorials: {
        activeTab: "1",
        searchText: "",
        tutorialsList: [],        
    }
}